<div class="col-12">
  <div class="card">
    <div class="card-header card-header-grey">
      <h4 class="card-title">
        Réponse aux annonces
      </h4>
    </div>
    <br />
    <div class="row" style="align-content: center">
      <div class="col-12 text-center" *ngIf="reponses.length === 0">Aucune réponse trouvée.</div>
      <div *ngFor="let rep of reponses" class="col-md-4">
        <mat-card style="margin-bottom: 2rem;width: 100%;min-height:250px;">
          <mat-card-header>
            <mat-card-title style="color: #000000">{{rep.emp_intitule}}</mat-card-title>
            <mat-card-subtitle>{{rep.repform_date}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <strong>Pièces jointes : </strong>
            <p *ngIf="!(rep.repform_piece_jointe1 || rep.repform_piece_jointe2)">
              Aucune pièce jointe
            </p>
            <br />
            <div *ngIf="rep.repform_piece_jointe1 || rep.repform_piece_jointe2">
              <p *ngIf="rep.repform_piece_jointe1">
                <label>Consulter mon CV </label>
                <a *ngIf="selected !== 'view-CV'" href="javascript:void(0)" (click)="onClick(rep);openDialogViewPj(rep.repform_piece_jointe1, 'view-CV')" class="btn btn-link btn-rose btn-just-icon like"><i class="material-icons">remove_red_eye</i></a>
                <button mat-icon-button *ngIf="rep.repform_piece_jointe1 && selected == 'view-CV'" (click)="onClear();"><mat-icon class="fa-rose">visibility_off</mat-icon></button>
              </p>
              <p *ngIf="rep.repform_piece_jointe2">
                <label>Consulter ma lettre de motivation </label>
                <a *ngIf="rep.repform_piece_jointe2 && selected !== 'view-CL'" href="javascript:void(0)" (click)="onClick(rep);openDialogViewPj(rep.repform_piece_jointe2, selected)" class="btn btn-link btn-rose btn-just-icon like"><i class="material-icons">remove_red_eye</i></a>
                <button mat-icon-button *ngIf="rep.repform_piece_jointe2 && selected == 'view-CL'" (click)="onClear();"><mat-icon class="fa-rose">visibility_off</mat-icon></button>
              </p>
            </div>
          </mat-card-content>
          <mat-card-actions class="text-center">
              <input type="button"
                     (click)="openDialogEdit()"
                     class="btn btn-next btn-fill btn-rose btn-wd"
                     value="MODIFIER"
                     style="margin-right:1rem;">
          </mat-card-actions>
        </mat-card>
      </div>
      <div class="col-md-12">
        <ngx-doc-viewer *ngIf="selected == 'view-CV' && (urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'odt'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'doc'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'docx'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'ppt'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'pptx'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'xls'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'xlsx')"
                        [url]="urlviewer" viewer="office" style=" width: 100%; height: 65vh;"></ngx-doc-viewer>
        <img *ngIf="(selected == 'view-CV') && urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'apng'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'bmp'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'gif'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'ico'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'jpeg' || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'jpg'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'png'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'svg'
                  || urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'tiff'"
             [src]="urlviewer" style="width:100%;" />
        <ngx-doc-viewer *ngIf="(selected == 'view-CV') && urlviewer?.substring(urlviewer?.lastIndexOf('.') + 1, urlviewer?.length) === 'pdf'" [url]="urlviewer" viewer="url" style="width:100%;height:65vh;"></ngx-doc-viewer>

        <ngx-doc-viewer *ngIf="selected == 'view-CL' && (urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'odt'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'doc'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'docx'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'ppt'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'pptx'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'xls'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'xlsx')"
                        [url]="urlviewerCL" viewer="office" style="width:100%;height:65vh;"></ngx-doc-viewer>
        <img *ngIf="selected == 'view-CL' && urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'apng'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'bmp'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'gif'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'ico'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'jpeg' || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'jpg'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'png'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'svg'
                  || urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'tiff'"
             [src]="urlviewerCL" style="width:100%;" />
        <ngx-doc-viewer *ngIf="(selected == 'view-CL') && urlviewerCL?.substring(urlviewerCL?.lastIndexOf('.') + 1, urlviewerCL?.length) === 'pdf'" [url]="urlviewerCL" viewer="url" style="width:100%;height:65vh;"></ngx-doc-viewer>
      </div>
    </div>
    <br />
  </div>
</div>
